export const AudioToggle = ({ on, onClick, icon, label, testId, ariaLabel }) => (
  <button className="audio-toggle" onClick={onClick} data-active={on} aria-pressed={on} aria-label={ariaLabel} data-testid={testId}>
    <span className="at-led" />
    {icon}
    <span className="at-label">{label}</span>
    <span className="at-state" data-testid={`${testId}-state`}>{on ? "on" : "off"}</span>
  </button>
);
